import { IPage } from '@/admin/helpers/interfaces/page-types';
import { IComponent } from '@/admin/helpers/interfaces/component-types'
import { addProps, deleteNestedItem, findNestedItem } from '@/helpers/helpers'
import { createModel } from '@rematch/core'
import { getPages, savepage, editpage, deletePage, importPages, getNewsLetter } from '../../../services/pagesService';
const initialState: { page: string, editMode: boolean, isloaded: boolean, pageDetails: IPage, pages: IPage[] } = {
    editMode: false,
    isloaded: false,
    page: "Dashboard",
    pageDetails: {
        _id: "",
        title: {},
        description: {},
        metaImage: "",
        url: {},
        updated_at: "",
        created_at: "",
        author: "",
        content: {

            type: " ",
            icon: " ",
            id: " ",
            category: "ATOMIC",
            props: {},
            childrens: [],
        }

    },
    pages: []
}
export const pageModel = createModel()({
    state: { ...initialState },
    reducers: {
        setPage(state, payload) {
            return {
                ...state,
                page: payload.page,
            }
        },
        setMode(state, payload) {
            return {
                ...state,
                editMode: payload.editMode,
            }
        },
        setPages(state, payload) {
            return {
                ...state,
                pages: payload.data,

            }
        },

        setContent(state, payload){
            return {
                ...state,
                pageDetails: {... state.pageDetails, content: payload}

            }
        },
        newPage(state, payload) {
            return {
                ...state,
                page: payload,

                pageDetails: {
                    _id: "",
                    pagesloaded: false,
                    title: {},
                    description: {},
                    url: {},
                    updated_at: "",
                    metaImage: "",
                    created_at: "",
                    author: "",
                    content: {
                        type: "Div",
                        id: "1",
                        category: "CONTAINER",
                        props: {},
                        childrens: []
                    }
 
                },

                // title: "untitled-page",
                // content: {
                //     type: "Div",
                //     id: "1",
                //     category: "CONTAINER",
                //     props: {className: ""},
                //     childrens: []
                // }
            }
        },
        newNewsLetter(state) {
            return {
                ...state,
                page: "EditNewsLetter",

                pageDetails: {
                    _id: "",
                    pagesloaded: false,
                    title: {},
                    description: {},
                    url: {},
                    updated_at: "",
                    metaImage: "",
                    created_at: "",
                    author: "",
                    content: {
                        type: "Div",
                        id: "1",
                        category: "CONTAINER",
                        props: {},
                        childrens: []
                    }

                },

                // title: "untitled-page",
                // content: {
                //     type: "Div",
                //     id: "1",
                //     category: "CONTAINER",
                //     props: {className: ""},
                //     childrens: []
                // }
            }
        },
        editPage(state, payload) {  // payload type object
            console.log(payload)
            return {
                ...state,
                page: payload.page,
                pageDetails: payload.tdata,

            }
        },
        addChild(state, payload) {
            const content = (state.pageDetails as { content: IComponent }).content;

            findNestedItem(content, payload.id, payload.component)


            return state;

        },
        deleteElement(state, payload) {

            const content = (state.pageDetails as { content: IComponent }).content;
            if (content.id === payload) {
                content.childrens = []
                return state
            } else if (content.childrens) {
                deleteNestedItem(content.childrens, payload);
            }

            return state
        },

        addProps(state, payload) {

            const content = (state.pageDetails as { content: IComponent }).content; //old
            addProps(content, payload.id, payload.props)

            return state;

        },
        setIsLoading(state, payload) {
            return {
                ...state,
                isloaded: payload

            }
        },

    },
    effects: (dispatch) => ({


        async getPagesAsync(payload, rootState) {
            const response = await getPages();
            if (response) {
                console.log(response.data)
                this.setPages({ data: response.data })
                return response
            } else {
                this.setPages({ data: [] })
                return {}
            }

        },

        async getNewsLetterAsync(payload, rootState) {
            const response = await getNewsLetter();
            if (response) {
                console.log(response.data)
                this.setPages({ data: response.data })
                return response
            } else {
                this.setPages({ data: [] })
                return {}
            }

        },

      

        async addPagesAsync(payload, rootState) {

            console.log(payload)
            return await savepage(payload);
          


        },
        async editPagesAsync(payload, rootState) {
            return await editpage(payload);

        },

        async deletePagesAsync(payload, rootState) {
            return await deletePage(payload);
        },

        async importPages(payload){

            return await importPages(payload)
        }
    }),
})